import React from 'react';

import LoginPhoneForm from '../components/forms/LoginPhoneForm';
import LoginLayout from '../components/layout/LoginLayout';

const LoginPhone = () => {
  return (
    <LoginLayout>
      <LoginPhoneForm />
    </LoginLayout>
  );
};

export default LoginPhone;
